import { render } from "./OrderReport.vue?vue&type=template&id=b580dc40&scoped=true"
import script from "./OrderReport.vue?vue&type=script&lang=js"
export * from "./OrderReport.vue?vue&type=script&lang=js"

import "./OrderReport.vue?vue&type=style&index=0&id=b580dc40&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b580dc40"]])

export default __exports__